import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  name: 'StudentGraduateDiscount',
  layout: 'default',
  head() {
    return {
      // @ts-ignore
      title: this.title,
      meta: [
        // @ts-ignore
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          // @ts-ignore
          content: this.description,
        },
      ],
      // @ts-ignore
      link: this.$hrefLangsPage(this.$route),
    };
  },
});

import { useContext, useRoute, onMounted, ref } from '@nuxtjs/composition-api';
import TLinkButton from '~/components/atoms/t-link-button.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const $route = useRoute();

const title = ref('Graduate Discount');
const description = ref(
  'As a student or recent graduate, you may be eligible for 50% off our amazing resources. To ensure your eligibility, please submit the request. After you submit the form a member of our customer support team will be in touch. If you have any questions please email'
);

expose({
  title,
  description,
});

return { __sfc: true,$route, title, description, TLinkButton }
}

})